export const ru = {
    'CollectionDefectIds.Gen.CANNOT_BE_EMPTY':
        'Не выбран параметр "Где искать"',
    'KeywordDefectIds.Gen.NO_RIGHTS_IN_ARCHIVED_ADGROUP':
        'Невозможно произвести действие над архивными группами: {validationResultValue}',
    'KeywordDefectIds.Keyword.MAX_KEYWORDS_PER_AD_GROUP_EXCEEDED':
        'Достигнут максимум фраз в группе:{maxKeywords}',
    'PhraseDefectIds.Gen.INVALID_EXCLAMATION_MARK':
        'Минус-слова содержат недопустимые символы',
    'PhraseDefectIds.Gen.INVALID_MINUS_MARK':
        'Минус-слова содержат недопустимые символы',
    'PhraseDefectIds.Gen.NO_PLUS_WORDS':
        'Замена невозможна: полностью удаляется ключевая фраза',
    'PhraseDefectIds.String.ILLEGAL_CHARACTERS':
        'Введены недопустимые символы: {allInvalidSubstrings}',
    'mutation-warning':
        'Операция занимает больше времени, чем обычно. Перезагрузите страницу через 30 минут, чтобы увидеть изменения.',
    'request-error': 'Обновите страницу либо попробуйте зайти позже',
    'unknown-error': 'Непредвиденная ошибка.'
};
